import { render, staticRenderFns } from "./DistribuicaoZona.vue?vue&type=template&id=3a0d9571&scoped=true&"
import script from "./DistribuicaoZona.vue?vue&type=script&lang=js&"
export * from "./DistribuicaoZona.vue?vue&type=script&lang=js&"
import style0 from "./DistribuicaoZona.vue?vue&type=style&index=0&id=3a0d9571&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0d9571",
  null
  
)

export default component.exports